import React, { useEffect, useRef, useState } from "react";

import Modal from "./Modal2";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isBusinessUserLoggedIn } from "../../store/slices/businessUser/slice";
import {
  ButtonNo,
  ButtonYes,
  CloseContainer,
  Gap,
  StyledText,
  Title,
} from "./QuantityModal.styles";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const QuantityModal = ({
  open,
  close,
  availableQuantity,
  onYes,
  zIndex,
  modalSubtitle,
}) => {
  const { t } = useTranslation();
  const [visibility, setVisibility] = useState(false);
  const loggedIn = useSelector(isBusinessUserLoggedIn);

  const handleKeyPress = (e) => {
    if (!loggedIn & open) {
      if (e.key === "Enter") {
      }
    }
  };

  useEffect(() => {
    if (!loggedIn && open) {
      document.addEventListener("keypress", handleKeyPress);
      return () => {
        document.removeEventListener("keypress", handleKeyPress);
      };
    }
  }, [loggedIn, open]);

  return (
    <Modal
      onClose={close}
      open={open}
      width={"777px"}
      height={"fit-content"}
      padding={"50px 60px"}
      unset
      className="modal-login"
      borderRadius={"1.2rem"}
      style={{
        zIndex: zIndex,
      }}
    >
      <CloseContainer onClick={close}>
        <CloseIcon fill="white" width={20} height={20} />
      </CloseContainer>
      <Gap>
        <Title>
          {t("sorry-only")} {availableQuantity} {t("can-be-purchased")}
        </Title>
        <StyledText>
          {modalSubtitle
            ? t(modalSubtitle)
            : `${t("would-you-like")} ${availableQuantity} ${t("to-your-cart")}`}
        </StyledText>
      </Gap>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 20,
          paddingInline: 80,
          paddingTop: 50,
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {!modalSubtitle && (
          <>
            <ButtonNo onClick={close} style={{ padding: "10px 24px" }}>
              {t("no")}
            </ButtonNo>
            <ButtonYes style={{ padding: "10px 24px" }} onClick={onYes}>
              {t("yes")}
            </ButtonYes>
          </>
        )}
      </div>
    </Modal>
  );
};

export default QuantityModal;
